export default "__VITE_PUBLIC_ASSET__369bb82c__"